import { useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import homeBg from "../assets/images/home.jpeg";

export default function PasswordReset() {
  const { t } = useTranslation("global");
  const { resetPassword } = useAuth();

  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    setLoading(true);

    try {
      await resetPassword(email);
      setMessage(
        t("Password_Reset_Sent.text") ||
          "Check your inbox for further instructions"
      );
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log(errorCode, errorMessage);
      setError(t("Alert5.text") + errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex items-center justify-center w-full relative h-screen bg-center bg-no-repeat bg-cover"
      style={{ backgroundImage: `url(${homeBg})` }}
    >
      <div className="bg-gray-800/50 bg-blend-multiply shadow-md rounded-lg px-8 py-6 max-w-md backdrop-filter backdrop-blur-md w-full">
        <h1 className="text-2xl font-bold text-center mb-4 dark:text-gray-200">
          {t("Reset_Password.text") || "Reset Password"}
        </h1>

        {error && (
          <div
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4"
            role="alert"
          >
            <span className="block sm:inline">{error}</span>
          </div>
        )}

        {message && (
          <div
            className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4"
            role="alert"
          >
            <span className="block sm:inline">{message}</span>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-300 mb-2"
            >
              {t("Email.text")}
            </label>
            <input
              type="email"
              id="email"
              className="w-full py-3 px-3 rounded-lg bg-gray-700/80 border border-gray-600 text-gray-400 font-semibold focus:border-[#fcab21] focus:outline-none"
              placeholder="flyxom@email.com"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-xl text-sm md:text-base text-white font-semibold bg-[#fcab21] hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#fcab21] disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
          >
            {loading ? "Loading..." : t("Send.text")}
          </button>
        </form>
        <div className="mt-4 text-center">
          <span className="text-sm text-gray-300">
            {t("Back_Login.text")}{" "}
            <NavLink
              to={"/login"}
              className="text-[#fcab21] hover:text-yellow-600 font-semibold focus:outline-none transition-colors duration-200"
            >
              {t("Login_Link.text")}
            </NavLink>
          </span>
        </div>
      </div>
    </div>
  );
}
